export enum EObservableElementProp {
  WIDTH = 'width',
  HEIGHT = 'height',
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left'
}

const { WIDTH, HEIGHT, TOP, BOTTOM, RIGHT, LEFT } = EObservableElementProp;

export interface IObservableElementProps {
  [WIDTH]?: number;
  [HEIGHT]?: number;
  [TOP]?: number;
  [RIGHT]?: number;
  [BOTTOM]?: number;
  [LEFT]?: number;
}

export const OBSERVABLE_ELEMENT_PROPS_SET = {
  SIZE: [WIDTH, HEIGHT],
  POSITION_SIMPLE: [TOP, LEFT],
  POSITION_EXTENDED: [TOP, RIGHT, BOTTOM, LEFT],
  SIZE_AND_POSITION: [WIDTH, HEIGHT, TOP, LEFT]
};
